var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#505152"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_196333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3891 15.965L21.6091 19.195L22.3591 19.955L23.0691 20.665C23.0991 20.495 23.1091 20.325 23.1091 20.155V13.585C23.1091 11.865 21.7091 10.475 19.9991 10.475C18.2791 10.475 16.8891 11.865 16.8891 13.585V14.455L17.6391 15.205L18.3891 15.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4391 20.055V17.045C26.4391 16.625 26.0991 16.295 25.6891 16.295C25.2791 16.295 24.9391 16.625 24.9391 17.045V20.055C24.9391 20.775 24.7691 21.455 24.4591 22.065L25.5591 23.175C26.1191 22.255 26.4391 21.195 26.4391 20.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6791 28.775C28.5291 28.925 28.3391 28.995 28.1491 28.995C27.9591 28.995 27.7691 28.925 27.6191 28.775L23.8691 25.015C22.9791 25.675 21.9191 26.115 20.7491 26.245V28.225H24.1791C24.5391 28.225 24.8291 28.515 24.8291 28.875C24.8291 29.235 24.5391 29.525 24.1791 29.525H15.8291C15.4691 29.525 15.1791 29.235 15.1791 28.875C15.1791 28.515 15.4691 28.225 15.8291 28.225H19.2491V26.245C16.0391 25.885 13.5491 23.245 13.5491 20.055V17.045C13.5491 16.625 13.8891 16.295 14.2991 16.295C14.7091 16.295 15.0491 16.625 15.0491 17.045V20.055C15.0491 22.665 17.2691 24.785 19.9991 24.785C21.0391 24.785 22.0091 24.475 22.8091 23.945L21.6491 22.775C21.1691 23.085 20.6091 23.255 19.9991 23.255C18.2791 23.255 16.8891 21.865 16.8891 20.155V17.995L11.3191 12.405C11.0291 12.115 11.0291 11.635 11.3191 11.345C11.6091 11.055 12.0891 11.055 12.3791 11.345L28.6791 27.715C28.9691 28.005 28.9691 28.485 28.6791 28.775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_196333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioh);
export default __webpack_public_path__ + "static/media/audioh.fa61d60782a549751804bf0c22519713.svg";
export { ForwardRef as ReactComponent };